module.exports = __webpack_public_path__ + "img/index-partners-banner-2.b171ae48.jpg";